/* Heartfield PDP scroll reveal. Progressive: nothing is hidden without JS, with reduced motion,
   in the theme editor, or for content already on screen at load. Timeline has its own animation. */
(function () {
  if (window.__hfAni) return;
  window.__hfAni = 1;
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (window.Shopify && Shopify.designMode) return;

  // [selector, mode, effect]  mode g = children of the match reveal together with a stagger, s = the match itself
  var MAP = [
    ['.hf-nv__head', 'g'], ['.hf-nv__media', 's', 'img'], ['.hf-nv__list', 'g', 'left'], ['.hf-nv__cta', 's'],
    ['.hf-meds__head', 'g'], ['.hf-meds__grid', 'g'], ['.hf-meds__note', 's'],
    ['.hf-auth__head', 'g'], ['.hf-auth__stats', 'g'], ['.hf-auth__sub', 's'], ['.hf-auth__grid', 'g'], ['.hf-auth__note', 's'], ['.hf-vid__head', 'g'],
    ['.hf-apart__head', 'g'], ['.hf-apart__media', 's', 'img'], ['.hf-apart__card', 'g'],
    ['.hf-cmp2__top', 'g'], ['.hf-cmp2__col--us', 'g', 'left'], ['.hf-cmp2__col--them', 'g', 'right'],
    ['.hf-cmp2__points', 'g'], ['.hf-cmp2__cta', 's'],
    ['.hf-ugc > .hf-wrap', 'g'],
    ['.hf-ingr__top', 's'], ['.hf-ingr__bottom > span', 's'], ['.hf-ingr__table', 'g'],
    ['.hf-tabs2-wrap', 'g'],
    ['.hf-guar > .hf-wrap', 'g'],
    ['.hf-faq__grid > div', 'g'],
    ['.hf-rv > h2', 's'], ['.hf-rv__sum', 'g'], ['.hf-rv__sort', 's'], ['.hf-rv__card', 's']
  ];
  var STEP = 70, MAX = 350;

  var pending = [];
  function show(host) {
    if (host.__hfDone) return;
    host.__hfDone = 1;
    (host.__hfAni || []).forEach(function (el) { el.classList.add('hf-on'); });
    io.unobserve(host);
  }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting) show(e.target); });
  }, { rootMargin: '0px 0px 0px 0px', threshold: 0 });

  // A fast flick can skip a small element between two frames; anything above the bottom edge gets shown
  var ticking = false;
  function sweep() {
    ticking = false;
    var fold = window.innerHeight;
    pending = pending.filter(function (h) {
      if (h.__hfDone) return false;
      if (h.getBoundingClientRect().top < fold) { show(h); return false; }
      return true;
    });
    if (!pending.length) window.removeEventListener('scroll', onScroll);
  }
  function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(sweep); } }

  function prep() {
    var fold = window.innerHeight;
    MAP.forEach(function (m) {
      document.querySelectorAll(m[0]).forEach(function (host) {
        if (host.__hfAni) return;
        if (host.getBoundingClientRect().top < fold) return; // already on screen: leave as is
        var items = m[1] === 'g' ? Array.prototype.slice.call(host.children) : [host];
        items.forEach(function (el, i) {
          el.classList.add('hf-ani');
          if (m[2]) el.classList.add('hf-ani--' + m[2]);
          el.style.setProperty('--hf-ani-d', Math.min(i * STEP, MAX) + 'ms');
        });
        host.__hfAni = items;
        pending.push(host);
        io.observe(host);
      });
    });
  }

  function start() { prep(); if (pending.length) window.addEventListener('scroll', onScroll, { passive: true }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();

  // Safety net: if the page is restored from cache or printed, show everything
  function showAll() { document.querySelectorAll('.hf-ani').forEach(function (el) { el.classList.add('hf-on'); }); }
  window.addEventListener('beforeprint', showAll);
  window.addEventListener('pageshow', function (e) { if (e.persisted) showAll(); });
})();
